/*
 * «Ссылки» кластера: metadata.links в стиле стандартной карточки ссылок (иконка + ссылка,
 * сеткой), иконки — из реестра приложения по links[].icon (cloud, dashboard, kubernetes, …).
 */
import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import { InfoCard, Link } from '@backstage/core-components';
import { useApp } from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(theme => ({
  icon: {
    display: 'inline-block',
    color: theme.palette.text.secondary,
    '& svg': {
      display: 'inline-block',
      fontSize: 'inherit',
      verticalAlign: 'baseline',
    },
  },
  muted: { color: theme.palette.text.secondary },
}));

export const ClusterLinksCard = () => {
  const classes = useStyles();
  const app = useApp();
  const { entity } = useEntity();
  const links = entity.metadata.links ?? [];
  return (
    <InfoCard title="Ссылки">
      {links.length === 0 ? (
        <Typography variant="body2" className={classes.muted}>
          Ссылок нет — задаются в metadata.links сущности кластера.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {links.map(link => {
            const Icon =
              (link.icon && app.getSystemIcon(link.icon)) || LanguageIcon;
            return (
              <Grid item xs={12} sm={6} key={link.url}>
                <Box display="flex">
                  <Box mr={1} className={classes.icon}>
                    <Typography component="div">
                      <Icon />
                    </Typography>
                  </Box>
                  <Box flexGrow={1}>
                    <Link to={link.url} target="_blank" rel="noopener">
                      {link.title ?? link.url}
                    </Link>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      )}
    </InfoCard>
  );
};
